import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getDjangoToken } from '@/utils/instagram/services/apiService';
import { customAuthAxios } from '@/utils/customAuthAxios';

const InstagramAuthCallback: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    useEffect(() => {
        const exchangeCodeForToken = async () => {
            const queryParams = new URLSearchParams(location.search);
            const code = queryParams.get('code');
            const restaurantId = queryParams.get('state'); // ✅ stateから取り出す！

            console.log("フロントで受け取ったcode:", code);
            console.log("フロントで受け取ったrestaurantId:", restaurantId);

            if (!code || !restaurantId) {
                setErrorMessage('認証コードまたはレストランIDがありません');
                return;
            }

            try {
                const djangoToken = await getDjangoToken();

                // await customAuthAxios.get('external_api/instagram-auth/code-receive/');

                await customAuthAxios.post(
                    `external_api/instagram-auth/code-receive/`,
                    {
                        restaurant_id: restaurantId,
                        code: code,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${djangoToken}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );

                console.log('Instagramアクセストークン保存成功！');
                navigate(`/restaurants/${restaurantId}/instagram/settings`);
            } catch (error) {
                console.error('アクセストークン交換エラー:', error);
                setErrorMessage('認証処理中にエラーが発生しました');
            }
        };

        exchangeCodeForToken();
    }, [location.search, navigate]);

    return (
        <div>
            {errorMessage ? (
                <p style={{ color: 'red' }}>{errorMessage}</p>
            ) : (
                <p>Instagram認証中です...</p>
            )}
        </div>
    );
};

export default InstagramAuthCallback;